import { useState } from 'react';
import { useRecoveryFlow } from 'src/auth/hooks/useRecoveryFlow';
import { RecoveryEmailForm } from 'src/auth/recovery/RecoveryEmailForm';
import { RecoveryCodeForm } from 'src/auth/recovery/RecoveryCodeForm';
import { ory } from 'src/providers/authProvider';
import { Logger } from 'src/utils/Logger';
import { AuthPageLayout } from 'src/auth/components/AuthPageLayout';
import { useFlags } from 'src/feature-flags/FlagsHook';

export const RecoveryPage = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { flagEnabledCustomSettingsFlow } = useFlags();

  const {
    isLoading,
    error,
    step,
    submittedEmail,
    defaultEmail,
    submitEmail,
    submitCode,
    goBackToEmail,
  } = useRecoveryFlow();

  const handleEmailSubmit = async (email: string) => {
    setIsSubmitting(true);
    await submitEmail(email);
    setIsSubmitting(false);
  };

  const handleCodeSubmit = async (code: string) => {
    setIsSubmitting(true);
    const { success } = await submitCode(code);
    setIsSubmitting(false);

    if (success) {
      try {
        const { data: settingsFlow } = await ory.createBrowserSettingsFlow();

        if (flagEnabledCustomSettingsFlow) {
          window.location.href = `/settings?flow=${settingsFlow.id}&source=recovery`;
        } else {
          window.location.href = settingsFlow.request_url;
        }
      } catch (error) {
        Logger.error('Failed to create settings flow after recovery', error);
        window.location.href = '/';
      }
    }
  };

  return (
    <AuthPageLayout isLoading={isLoading}>
      {step === 'email' ? (
        <RecoveryEmailForm
          defaultEmail={defaultEmail}
          error={error}
          isSubmitting={isSubmitting}
          onSubmit={handleEmailSubmit}
        />
      ) : (
        <RecoveryCodeForm
          email={submittedEmail}
          error={error}
          isSubmitting={isSubmitting}
          onSubmit={handleCodeSubmit}
          onBack={goBackToEmail}
        />
      )}
    </AuthPageLayout>
  );
};
